import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { reduce } from "et3-type-guards";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import getDashBoardStore from "../../../stores/dashboard-store";
import { getKhattabatAssignStore } from "../../../stores/khattabat-stores/assign-store";
import {
  E_ADMIN_ROLE,
  E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE
} from "../../../Types";

const KhattabatClientAssignPopUp = withLiteObserverAndTheme(() => {
  const {
    selectedClientType,
    toggleSelectedClientType,
    assignClientToKhattaba
  } = getKhattabatAssignStore();
  const { totalUnassignedKhattabatClients, totalUnassignedKhattabatTesters } =
    getDashBoardStore();
  const userRole = reduce(() => getCorePersonalStore().user.get().role, "");
  const isTesterDisabled = userRole !== E_ADMIN_ROLE.KHATTABA_ADMIN_TESTER;
  const closePopUp = () => getCorePopUpStore().closeConfirmationPopUps();

  return (
    <Dialog open fullWidth maxWidth="xs" onClose={closePopUp}>
      <DialogTitle>
        {i18n.get("ASSIGN_NEW_CLIENT_CONFIRMATION_POP_UP")}
      </DialogTitle>
      <DialogContent>
        <RadioGroup
          value={selectedClientType.get()}
          onChange={({ target }) => {
            if (target.value !== selectedClientType.get()) {
              toggleSelectedClientType();
            }
          }}
        >
          <FormControlLabel
            value={E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE.TESTER}
            disabled={isTesterDisabled}
            control={<Radio color="error" />}
            label={`${i18n.get("KHATTABAT_ASSIGN_TESTER_USERS")} (${totalUnassignedKhattabatTesters.get()})`}
            sx={{ color: "error.main" }}
          />
          <FormControlLabel
            value={E_KHATTABAT_ASSIGN_CLIENT_USER_TYPE.REAL}
            control={<Radio />}
            label={`${i18n.get("KHATTABAT_ASSIGN_REAL_USERS")} (${totalUnassignedKhattabatClients.get()})`}
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={closePopUp}>{i18n.get("CANCEL")}</Button>
        <Button variant="contained" onClick={assignClientToKhattaba}>
          {i18n.get("CONFIRM")}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default KhattabatClientAssignPopUp;
